export default {"src":"/_next/static/media/github-mark-white.fd5c0afd.svg","height":96,"width":98,"blurWidth":0,"blurHeight":0};